export interface AppConfig {
  serverUrl?: string;
  serverUrlTest?: string;
  // Extend with other fields from config.json as needed
  [key: string]: unknown;
}

let cachedConfig: AppConfig | null = null;
let inFlightConfigPromise: Promise<AppConfig> | null = null;

export const loadAppConfig = async (): Promise<AppConfig> => {
  if (cachedConfig) return cachedConfig;
  if (inFlightConfigPromise) return inFlightConfigPromise;

  inFlightConfigPromise = fetch("/config.json")
    .then(async (res) => {
      const cfg: AppConfig = await res.json();
      cachedConfig = cfg;
      return cfg;
    })
    .finally(() => {
      inFlightConfigPromise = null;
    });

  return inFlightConfigPromise;
};

export const resolveApiBaseUrl = (config: AppConfig): string => {
  const isDev = typeof process !== "undefined" &&
    (process as any)?.env?.NODE_ENV === "development";
  const isTestHost = typeof window !== "undefined" &&
    (window.location.hostname.includes("test") || window.location.hostname.includes("local"));

  const useTest = isDev || isTestHost;
  return useTest ? String(config.serverUrlTest || "") : String(config.serverUrl || "");
};

